/* eslint-disable no-console */
import React, { useRef, useState } from 'react';
import SlickSlider from 'react-slick';
import convert from 'htmr';
import classnames from 'classnames';
import { filter, includes, isEmpty } from 'lodash/fp';
import transform from '../_utils/convertTransformSVG';
import IconArrow from '../../files/arrow.svg';

const MAX_DOTS = 20;
const FOCUSABLE_TAGNAMES = [
  'A',
  'BUTTON',
  'INPUT',
  'AREA',
  'SELECT',
  'TEXTAREA',
  'AUDIO',
  'VIDEO',
  'EMBED',
  'SVG', // because IE11
];

const NextArrow = ({ className, style, onClick }) => (
  <button
    className={`${className} slider__arrow slider__arrow--next`}
    style={style}
    onClick={onClick}
  >
    <IconArrow focusable={false} />
  </button>
);

const PrevArrow = ({ className, style, onClick }) => (
  <button
    className={`${className} slider__arrow slider__arrow--prev`}
    style={style}
    onClick={onClick}
  >
    <IconArrow focusable={false} />
  </button>
);

const Slider = ({ children, proxy, className, ...customSettings }) => {
  const sliderRef = useRef(null);
  let slides;
  let numSlides;

  if (isEmpty(children)) {
    if (proxy && !isEmpty(proxy.innerHTML)) {
      slides = convert(proxy.innerHTML.trim(), { transform });
      numSlides = filter('type', slides).length;
    } else {
      slides = null;
      numSlides = 0;
    }
  } else {
    slides = children;
    numSlides = slides.length;
  }

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const defaultSettings = {
    afterChange: setCurrentSlideIndex,
    dots: numSlides <= MAX_DOTS,
    dotsClass: 'slider__dots slick-dots',
    infinite: true,
    nextArrow: <NextArrow />,
    pauseOnDotsHover: true,
    pauseOnFocus: true,
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false,
        },
      },
    ],
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    ...customSettings,
  };

  const wrapperClasses = classnames('slider', className, {
    'slider--no-dots': numSlides > MAX_DOTS,
  });

  const handleFocus = (evt) => {
    evt.persist();
    evt.preventDefault();
    const { target } = evt;
    if (includes(target.tagName, FOCUSABLE_TAGNAMES)) {
      const slide = target.closest('.slick-slide');
      if (slide) {
        const slideIndex = slide.dataset.index;
        sliderRef.current.slickGoTo(slideIndex);
      }
    }
  };

  return (
    <div className={wrapperClasses} onFocus={handleFocus}>
      <SlickSlider {...defaultSettings} ref={sliderRef}>
        {slides}
      </SlickSlider>
      <div className="slider__pagination">
        <span className="slider__current-index">{currentSlideIndex + 1}</span>
        &nbsp;/&nbsp;<span className="slider__slide-count">{numSlides}</span>
      </div>
    </div>
  );
};

export default Slider;
